import styled from 'styled-components';

import { MobileModal } from '@components/organisms/MobileModal/MobileModal';

export const RedirectModalContainer = styled(MobileModal.Container)`
    align-content: space-between;
    display: grid;
    gap: 32px;
    padding-bottom: 24px;
`;

export const RedirectModalInner = styled.div`
    display: grid;
    gap: 32px;
    text-align: center;
    justify-items: center;
`;

export const RedirectModalButtons = styled.div`
    display: grid;
    gap: 12px;
`;
